require('angular')
modules = []

angular.module 'gnp-truncate', modules
  .filter 'gnpTruncate', ->
    (value, wordwise, max, tail) ->
      if !value
        return ''
      max = parseInt(max, 10)
      if !max
        return value
      if value.length <= max
        return value
      value = value.substr(0, max)
      if wordwise
        lastspace = value.lastIndexOf(' ')
        if lastspace != -1
          #Also remove . and , so its gives a cleaner result.
          if value.charAt(lastspace - 1) == '.' or value.charAt(lastspace - 1) == ','
            lastspace = lastspace - 1
          value = value.substr(0, lastspace)
      value + (tail or ' …')




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/truncate/truncate_module.coffee